<script setup lang="ts">
import { computed } from "vue";

const page = usePage().value;
const trekGrades = computed(() => page?.trekGrades ?? []);
const currentSlide = ref(0);

const windowWidth = ref(0); // default value
const isMobile = computed(() => windowWidth.value <= 992);

const itemsToShow = ref(1);
const itemsToScroll = ref(1);

function updateWidth() {
  windowWidth.value = window.innerWidth;

  // Adjust itemsToShow and itemsToScroll based on isMobile value
  if (isMobile.value) {
    itemsToShow.value = 1;
    itemsToScroll.value = 1;
  } else {
    itemsToShow.value = 1;
    itemsToScroll.value = 1;
  }
}

onMounted(() => {
  // Initialize window width and set the correct values
  updateWidth();

  // Add resize event listener to update values on resize
  window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});
</script>

<template>
  <section id="trekGrades">
    <header>
      <h2>How We Grade Our Treks</h2>
    </header>

    <Carousel
      v-model="currentSlide"
      :items-to-show="itemsToShow"
      :items-to-scroll="itemsToScroll"
      :wrap-around="false"
    >
      <Slide v-for="grade in trekGrades" :key="grade.id">
        <div class="carousel__item">
          <div class="grade-title">
            <div class="grade-icon" v-html="grade.gradeimage" />
            <h3 v-html="grade.trek_grade.replace('-', '<br />')"></h3>
            <div class="intro" v-html="grade.intro" />
          </div>
          <div class="grade-info">
            <div class="info-box">
              <div class="info-wrap">
                <div class="info1" v-html="grade.text" />
                <div class="info2" v-html="grade.text2" />
              </div>
            </div>
            <div class="view-grade-treks"></div>
            <!-- <div
              v-for="trek in grade.trekSuggestions"
              :key="trek.slug"
              class="view-grade-treks"
            >
             <NuxtLink :to="`/${trek.slug}`">
                {{ trek.title }}
              </NuxtLink>
            </div> -->
          </div>
        </div>
      </Slide>
      <template #addons>
        <Navigation />
        <Pagination />
      </template>
    </Carousel>
  </section>
</template>
